import { lsGet } from '@modules/localStorage/methods/lsGet';
import { LocalStorageKeys } from '@modules/localStorage/types/localStorageKeys.type';

export const getChatVisibility = () => {
	return lsGet(LocalStorageKeys.CHAT_VISIBLE, false);
};
